export default "__VITE_ASSET__79f9f40c__"